module.exports = __webpack_public_path__ + "img/small_text_green_cut.96b02e7a.png";